// Module
var code = `<table class="table">
  <thead>
  <tr>
    <th class="no-column-header">No</th>
    <th>Account No.</th>
    <th>Account Name</th>
    <th>Balance</th>
    <th>Added By</th>
    <th>Added on</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="account in \$ctrl.accountGroup.accounts">
    <td>{{\$index + 1}}</td>
    <td>{{account.productNumber}}</td>
    <td>{{account.accountName}}</td>
    <td>{{account.balance | nxCurrency}}</td>
    <td>{{account.addedByUser}}</td>
    <td>{{account.addedToGroupOn | prettyDate}}</td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/account-group/members/account-group-members.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;